import { Slot } from "@radix-ui/react-slot";

export function resolveElement<E extends React.ElementType>(
  asChild?: boolean,
  as?: E,
  fallback: React.ElementType = "div",
) {
  return asChild ? Slot : (as ?? fallback);
}
